<template>
    <section class="our-projects-section main-slider-modules">
        <div class="our-projects-title-container">
            <div class="section-title-box">
                <!-- <h3 class="section-title">Категории</h3> -->
            </div>
        </div>
        <div class="container-right">
            <div class="our-projects-slider--outer">   
                <swiper
                    :slidesPerView="1"
                    :spaceBetween="18"
                    :pagination="{
                      el: pagination,
                      type: 'fraction',
                      clickable: true,
                        formatFractionCurrent: function(num){
                            return (num > 9) ? num : '0' + num;
                        },
                        formatFractionTotal: function(num){
                            return (num > 9) ? num : '0' + num;
                        },

                    }"
                    :modules="modules"
                    :navigation="{
                      prevEl: prev,
                      nextEl: next,
                    }"
                    :breakpoints="{
                      '375': {
                        slidesPerView: 2,
                      },
                      '1024': {
                        slidesPerView: 3,
                      },
                    }"
                    class="projectsSlider"
                >
                
                    <swiper-slide class="project-slide">
                        <a class="project-link" href="#">
                            <span class="project-link__img-box">
                                <span class="img-wrap project-img-wrap">
                                    <img src="images/projects/01.webp" class="image project-image" alt=""/>
                                </span>
                            </span>
                            <span class="project-link__title-box">
                                <span class="title">Мангали</span>
                            </span>
                        </a>
                    </swiper-slide>
                    <swiper-slide class="project-slide">
                        <a class="project-link" href="#">
                            <span class="project-link__img-box">
                                <span class="img-wrap project-img-wrap">
                                    <img src="images/projects/02.webp" class="image project-image" alt=""/>
                                </span>
                            </span>
                            <span class="project-link__title-box">
                                <span class="title">Решотки</span>
                            </span>
                        </a>
                    </swiper-slide>
                    <swiper-slide class="project-slide">
                        <a class="project-link" href="#">
                            <span class="project-link__img-box">
                                <span class="img-wrap project-img-wrap">
                                    <img src="images/projects/03.webp" class="image project-image" alt=""/>
                                </span>
                            </span>
                            <span class="project-link__title-box">
                                <span class="title">Ворота</span>
                            </span>
                        </a>
                    </swiper-slide>
                    <swiper-slide class="project-slide">
                        <a class="project-link" href="#">
                            <span class="project-link__img-box">
                                <span class="img-wrap project-img-wrap">
                                    <img src="images/projects/05.webp" class="image project-image" alt=""/>
                                </span>
                            </span>
                            <span class="project-link__title-box">
                                <span class="title">Лестница</span>
                            </span>
                        </a>
                    </swiper-slide>
                    <swiper-slide class="project-slide">
                        <a class="project-link" href="#">
                            <span class="project-link__img-box">
                                <span class="img-wrap project-img-wrap">
                                    <img src="images/projects/06.webp" class="image project-image" alt=""/>
                                </span>
                            </span>
                            <span class="project-link__title-box">
                                <span class="title">Лестница</span>
                            </span>
                        </a>
                    </swiper-slide>
                    <swiper-slide class="project-slide">
                        <a class="project-link" href="#">
                            <span class="project-link__img-box">
                                <span class="img-wrap project-img-wrap">
                                    <img src="images/projects/07.webp" class="image project-image" alt=""/>
                                </span>
                            </span>
                            <span class="project-link__title-box">
                                <span class="title">Лестница</span>
                            </span>
                        </a>
                    </swiper-slide>
                </swiper>
               
            </div>
            <div class="swiper-nav">
                    <div ref="next" class="swiper-button-next">
                        <swiper-icon-left/>
                    </div>
                    <div ref="prev" class="swiper-button-prev">
                        
                        <swiper-icon-right/>
                    </div>
                </div> 
        </div>
    </section>
</template>
<script setup>
import {ref, defineProps, onMounted} from 'vue';
import { useStore } from 'vuex'

import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Pagination} from 'swiper/modules';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
const store = ref(useStore())
const props = defineProps({
    projects: Object
})

const components = {
    Swiper,
    SwiperSlide,
}
const modules = [
    Navigation,
    Pagination
]

const prev = ref(null);
const next = ref(null);
const pagination = ref(null);
onMounted(() => {
    prev
    next
    pagination
})
</script>
